import { Box } from '@chakra-ui/react';

export interface CardProps {
  children: React.ReactNode;
}

const Card = ({ children }: CardProps) => {
  return (
    <Box bg="bg" borderRadius="md" p="4">
      {children}
    </Box>
  );
};

const MemoizedCard = memo(Card);
export { MemoizedCard as Card };
